var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmazon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "286px",
    height: "286px",
    viewBox: "0 0 286 286",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "amazon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "amazon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(5.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    fill: "#484848"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 138.5,
    cy: 138.5,
    r: 138.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "amazon-svgrepo-com",
    transform: "translate(66.834302, 63.613372)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.355872,122.388965 C65.2210602,151.53262 27.2795121,127.149309 2.99223565,112.338725 C1.48975137,111.405124 -1.06498123,112.557075 1.15156507,115.106877 C9.24257027,124.934175 35.7596353,148.620601 70.3722893,148.620601 C105.008372,148.620601 125.613798,129.689929 128.19145,126.387634 C130.751276,123.113398 128.943201,121.306906 126.355872,122.388965 Z M143.525448,112.891233 C141.88392,110.750073 133.54284,110.350614 128.293822,110.996482 C123.035637,111.623474 115.144284,114.842102 115.830333,116.774095 C116.18278,117.498528 116.901426,117.173554 120.5135,116.848579 C124.134742,116.486362 134.279822,115.204319 136.393995,117.972471 C138.517846,120.758989 133.157797,134.03755 132.1794,136.17871 C131.233598,138.319871 132.541014,138.872379 134.317002,137.446469 C136.069561,136.020559 139.241076,132.328499 141.36951,127.103395 C143.483684,121.850231 144.772764,114.521209 143.525448,112.891233 Z",
    id: "Shape",
    fill: "#F4B459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.88334,76.126231 L110.88334,27.3228782 C110.88334,18.9398557 102.787751,0 73.6925249,0 C44.6018826,0 29.1247665,18.2108307 29.1247665,34.6146588 L53.4395461,36.7930611 C53.4395461,36.7930611 58.8551106,20.3984159 71.425047,20.3984159 C83.9949833,20.3984159 83.1327101,30.5976238 83.1327101,32.803575 L83.1327101,43.4068332 C67.0296438,43.9501583 27.0426798,48.5574536 27.0426798,82.3313614 C27.0426798,118.65048 72.811407,120.173831 87.820461,96.7011638 C88.4000635,97.6531307 89.05861,98.5867317 89.883703,99.4601333 C95.4062241,105.274988 102.77349,112.204552 102.77349,112.204552 L121.542829,93.6269128 C121.552507,93.6218111 110.88334,85.233687 110.88334,76.126231 Z M55.2664651,77.8398735 C55.2664651,62.2395543 71.9537177,59.0765347 83.1372939,58.7051349 L83.1372939,72.1321535 C83.1327101,98.7305981 55.2664651,94.70387 55.2664651,77.8398735 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazon);
export default __webpack_public_path__ + "static/media/amazon.24f49d94530483c6c2807ec9947dcedd.svg";
export { ForwardRef as ReactComponent };